export default {
    "APP_NAME": "sfsre",
    "API":  "https://sflschoolofrealestate.com/api", //"http://localhost:5000"
    "URL_SITE": "https://sflschoolofrealestate.com"
}